import React from "react";
import ChaptersRow from "./ChaptersRow";

const ChaptersView = ({ summarySections }) => (
  <div className="literary-devices chapters">
    {summarySections.length ? (
      summarySections.map((ss, index) => (
        <ChaptersRow index={index} key={ss.id} summarySection={ss} />
      ))
    ) : (
      <em className="text-center no-matches">No matches.</em>
    )}
  </div>
);
export default ChaptersView;
